"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var SvgHooray = function SvgHooray() {
  return (0, _jsxRuntime.jsxs)("svg", {
    viewBox: "0 0 69 69",
    fill: "none",
    children: [(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23.856 13.99c1.06 0 1.924.863 1.924 1.925 0 1.06-.863 1.924-1.924 1.924a1.927 1.927 0 01-1.925-1.924c0-1.062.863-1.925 1.925-1.925zm-4.925 1.925a4.93 4.93 0 004.925 4.924 4.93 4.93 0 004.924-4.924 4.93 4.93 0 00-4.924-4.925 4.93 4.93 0 00-4.925 4.925zM54.507 47.906a1.926 1.926 0 01-1.925-1.925c0-1.06.863-1.925 1.925-1.925 1.061 0 1.924.864 1.924 1.925a1.926 1.926 0 01-1.924 1.925zm0-6.85a4.93 4.93 0 00-4.925 4.925 4.93 4.93 0 004.925 4.925 4.93 4.93 0 004.924-4.925 4.93 4.93 0 00-4.924-4.925zM41.03 19.59a1.5 1.5 0 10.002-2.999 1.5 1.5 0 00-.001 2.999zM33.824 31.096a1.5 1.5 0 103-.001 1.5 1.5 0 00-3 0zM56.435 21.82a1.5 1.5 0 10-.001-3 1.5 1.5 0 00.001 3zM52.224 33.01a1.5 1.5 0 10.001 3.002 1.5 1.5 0 000-3.001z",
      fill: "#21285E"
    }), (0, _jsxRuntime.jsx)("mask", {
      id: "hooray_svg__a",
      maskUnits: "userSpaceOnUse",
      x: 62,
      y: 43,
      width: 4,
      height: 4,
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M62.86 43.495h3v3h-3v-3z",
        fill: "#fff"
      })
    }), (0, _jsxRuntime.jsx)("g", {
      mask: "url(#hooray_svg__a)",
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M64.36 43.495a1.5 1.5 0 10-.002 2.999 1.5 1.5 0 00.002-2.999z",
        fill: "#21285E"
      })
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.146 8.282a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
      fill: "#21285E"
    }), (0, _jsxRuntime.jsx)("mask", {
      id: "hooray_svg__b",
      maskUnits: "userSpaceOnUse",
      x: 42,
      y: 3,
      width: 12,
      height: 12,
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M42.602 3h11.103v11.103H42.602V3z",
        fill: "#fff"
      })
    }), (0, _jsxRuntime.jsx)("g", {
      mask: "url(#hooray_svg__b)",
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M48.154 6.621l1.93 1.931-1.93 1.93-1.931-1.93 1.93-1.93zm-1.061 7.043a1.495 1.495 0 002.122 0l4.05-4.052a1.5 1.5 0 000-2.12l-4.05-4.053a1.5 1.5 0 00-2.122 0l-4.051 4.052a1.5 1.5 0 000 2.121l4.05 4.052z",
        fill: "#21285E"
      })
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M44.102 27.395c.384 0 .769-.146 1.062-.44a17.92 17.92 0 016.98-4.32 1.499 1.499 0 10-.948-2.845 20.968 20.968 0 00-8.156 5.044 1.498 1.498 0 001.062 2.561zM27.491 29.125a1.495 1.495 0 002.119-.098 27.57 27.57 0 007.213-18.622 1.5 1.5 0 00-3 0 24.58 24.58 0 01-6.43 16.601 1.5 1.5 0 00.098 2.119z",
      fill: "#21285E"
    }), (0, _jsxRuntime.jsx)("mask", {
      id: "hooray_svg__c",
      maskUnits: "userSpaceOnUse",
      x: 4,
      y: 25,
      width: 45,
      height: 43,
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 25.737h44.63v41.308H4V25.737z",
        fill: "#fff"
      })
    }), (0, _jsxRuntime.jsx)("g", {
      mask: "url(#hooray_svg__c)",
      children: (0, _jsxRuntime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.628 54.862l-2.045-4.479a1.499 1.499 0 10-2.728 1.247l1.96 4.291-10.2 3.837-4.02-8.806 5.4-14.352 4.496 9.852a1.5 1.5 0 102.73-1.246L19.484 32.64l1.016-2.698 20.602 20.601-11.475 4.319zm-18.523.05l2.696 5.907-5.73 2.155 3.034-8.063zm35.553-20.684a27.687 27.687 0 00-10.875 6.753L20.978 26.175a1.502 1.502 0 00-2.465.533L4.096 65.017a1.502 1.502 0 001.932 1.933l38.31-14.416a1.5 1.5 0 00.531-2.465l-6.966-6.966a24.67 24.67 0 019.7-6.025 1.5 1.5 0 00-.945-2.849z",
        fill: "#21285E"
      })
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M63.105 27.285h.731a1.5 1.5 0 100-3h-.731v-.732a1.5 1.5 0 10-3 0v.732h-.732a1.5 1.5 0 100 3h.732v.731a1.5 1.5 0 103 0v-.73z",
      fill: "#21285E"
    })]
  });
};

var _default = SvgHooray;
exports["default"] = _default;